<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesFiltersCheckboxGroup from './SalesFiltersCheckboxGroup.vue';

const props = defineProps({
  activeList: { type: String, required: true },
  agents: { type: Array, default: () => [] },
  filters: { type: Object, required: true },
  postSaleStatuses: { type: Array, default: () => [] },
  query: { type: String, default: '' },
});

const emit = defineEmits(['toggle', 'update-query', 'submit']);
const { t } = useI18n();
const delivered = computed(() => props.activeList === 'entregues');
const drafts = computed(() =>
  ['rascunhos', 'arquivados'].includes(props.activeList)
);
const managerOptions = computed(() =>
  props.agents.map(agent => ({ value: agent.id, label: agent.name }))
);
const statusOptions = computed(() =>
  props.postSaleStatuses.map(option => ({
    value: option.id,
    label: option.label,
  }))
);
const draftOptions = computed(() => [
  { value: 'fazendo', label: t('SALES.FILTERS.DOING') },
  { value: 'pronto', label: t('SALES.FILTERS.READY') },
]);
const toggle = (key, value) => emit('toggle', { key, value });
</script>

<template>
  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <label
      class="flex flex-col gap-1 text-sm font-semibold text-lais-text-body md:col-span-2"
    >
      {{ t('SALES.FILTERS.SEARCH') }}
      <input
        :value="query"
        type="search"
        class="min-h-10 rounded-lais border border-lais-border px-3 font-normal"
        @input="emit('update-query', $event.target.value)"
        @keyup.enter="emit('submit')"
      />
    </label>
    <SalesFiltersCheckboxGroup
      :title="t('SALES.FILTERS.MANAGER')"
      :options="managerOptions"
      :values="filters.manager_user_id"
      @toggle="toggle('manager_user_id', $event)"
    />
    <SalesFiltersCheckboxGroup
      v-if="delivered"
      :title="t('SALES.FILTERS.RESPONSIBLE')"
      :options="managerOptions"
      :values="filters.responsible_user_id"
      @toggle="toggle('responsible_user_id', $event)"
    />
    <SalesFiltersCheckboxGroup
      v-if="delivered"
      :title="t('SALES.FILTERS.POST_SALE_STATUS')"
      :options="statusOptions"
      :values="filters.post_sale_status"
      @toggle="toggle('post_sale_status', $event)"
    />
    <SalesFiltersCheckboxGroup
      v-if="drafts"
      :title="t('SALES.FILTERS.DRAFT_STATUS')"
      :options="draftOptions"
      :values="filters.draft_status"
      @toggle="toggle('draft_status', $event)"
    />
  </div>
</template>
